import script from "./PetDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PetDetails.vue?vue&type=script&setup=true&lang=js"

import "./PetDetails.vue?vue&type=style&index=0&id=6211874b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6211874b"]])

export default __exports__